import { planUtils } from 'utils/plan/plan.utils';

export const getSubscriptionTier = (subscription: Subscription, plan?: Plan): string => {
  if (subscription?.aa_rcp) {
    return 'pro_aa';
  }

  if (subscription?.rcp) {
    return 'pro_custom_settings';
  }

  const planType = planUtils.getType(plan);

  if (planType === 'dedicated') {
    return 'dedicated';
  }

  if (planType === 'pro') {
    return 'pro_easy_create';
  }

  if (planType === 'essential') {
    if (planUtils.getIsFree(plan)) {
      return 'free';
    }

    if (planUtils.getIsRedisFlexEssentials(plan)) {
      return 'essentials_flex';
    }

    return 'essentials';
  }

  return 'pro';
};
